import type { AttachmentPreviewKind } from '../Common/AttachmentPreviewDialog'

export const DESIGN_IMPORT_DRAFT_STORAGE_KEY = 'timelining:design-import-draft'

export type DesignImportDraft = {
  id: string
  name: string
  url: string
  mimeType?: string
  sizeBytes?: number
  kind: AttachmentPreviewKind
  createdAt: number
}

export const writeDesignImportDraft = (draft: DesignImportDraft) => {
  window.localStorage.setItem(DESIGN_IMPORT_DRAFT_STORAGE_KEY, JSON.stringify(draft))
}

export const readDesignImportDraft = (): DesignImportDraft | null => {
  const raw = window.localStorage.getItem(DESIGN_IMPORT_DRAFT_STORAGE_KEY)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as Partial<DesignImportDraft>
    if (!parsed.id || !parsed.name || !parsed.url || !parsed.kind) return null
    return {
      id: parsed.id,
      name: parsed.name,
      url: parsed.url,
      mimeType: parsed.mimeType,
      kind: parsed.kind,
      createdAt: typeof parsed.createdAt === 'number' ? parsed.createdAt : Date.now(),
    }
  } catch {
    return null
  }
}

export const clearDesignImportDraft = () => {
  window.localStorage.removeItem(DESIGN_IMPORT_DRAFT_STORAGE_KEY)
}
